module.exports = __webpack_public_path__ + "img/img-4-mobile.157e1174.png";